module.exports = __webpack_public_path__ + "static/media/ils_hassle_free.d1add918.svg";